var fileHost = "https://cdn2024.shiwuzone.com/"; //你的oss地址
var config = {
  //aliyun OSS config
  uploadImageUrl: `${fileHost}`,
  AccessKeySecret: '', //登录oss控制台查看
  OSSAccessKeyId: '', //登录oss控制台查看
  SecurityToken: '', // 使用STS签名必传
  timeout: 87600
};
module.exports = config